import { SellTicketProductModelType } from '@teinor/erp/types/company/order/sell/sellTicket/sellTicketProduct'
import { ProductTicketTPVDSBProps } from '../..'
import { permissionCheck } from '../../../../../../../../../baseComponents/PermissionChecker/function'
import { ITDiscountDisplay, ITTypeQuantityDisplay } from '../../../../../../../../../baseComponents/TwinTable/InputTableLayout/InputTable/Components/Displays'
import { CustomRenderString } from '../../../../../../../../../baseComponents/TwinTable/VirtualTableListing/CustomRenders'
import { ColumnOrderTableSchema } from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderLayout/types'
import OrderSellTicketTPVLayout from '../../../../../../../../../specificComponents/inputTableLayouts/order/OrderSellTicketTPVLayout'
import { ProductExtendedTyInputTableListing } from '../../../../../../../../../specificComponents/Product/types'
import useTwinTranslation from '../../../../../../../../../utils/hooks/useTwinTranslation'
import { getUserPermissions } from '../../../../../../../../../utils/reducers/getters'
import SellTicketCreateStepButtons from '../SellTicketCreateStep/SellTicketCreateStepButtons'

interface SellTicketCreateNoPermissionStepProps extends ProductTicketTPVDSBProps { }

const SellTicketCreateNoPermissionStep: React.FC<SellTicketCreateNoPermissionStepProps> = ({ completeData, inputTableURLs, orderHeaderURLs, setCompleteData, setTableConfiguration, tableConfiguration, getCompleteData, title }) => {
    const { t } = useTwinTranslation()
    const priceColumns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellTicketProductModelType> = []
    const priceColumns2: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellTicketProductModelType> = []
    const hidePrices = completeData?.header?.hidePrices
    if (!hidePrices) {
        priceColumns.push(
            {
                id: 'initialUnitPriceWithTax',
                dataKey: 'initialUnitPriceWithTax',
                simpleLabel: t('price', 'Precio'),
                label: () => <div className='text-right w-full mr-10'>{t('price', 'Precio')}</div>,
                component: 'ITDisplayPrice',
                typeOnChange: 'onChangeTotalsFetch',
                width: 105,
                sortable: true,
            },
        )
        priceColumns2.push(
            {
                id: 'discount',
                dataKey: 'discount',
                label: t('discount', 'Descuento'),
                width: 90,
                customRender: (parameterValue, allRowData) => <ITDiscountDisplay CurrencyId={completeData?.header.CurrencyId} value={parameterValue} typeDiscount={allRowData.typeDiscount} />
            },
            {
                id: 'rowPriceWithTaxAndTotalDiscount',
                dataKey: 'rowPriceWithTaxAndTotalDiscount',
                label: () => <div className='text-right w-full'>{t('priceTotal', 'Precio Total')}</div>,
                simpleLabel: t('priceTotal', 'Precio Total'),
                component: 'ITDisplayEditFinalPriceBase',
                skipEdit: true,
                with_vat: true,
                width: 105,
            },
            {
                id: 'totalWithTaxWithComplements',
                dataKey: 'totalWithTaxWithComplements',
                simpleLabel: t('totalWithComplementsAndVat', 'Total con complementos e imp.'),
                label: () => <div className='text-right w-full' >{t('withComplementsAndVatS', 'Con comp. e imp.')}</div>,
                component: 'ITDisplayEditFinalPriceBase',
                skipEdit: true,
                with_vat: true,
                width: 105,
                hideColumnByDefault: true,
                toolTip: t('totalWithComplementsAndVatL', 'Total con complementos e impuestos'),
            },
            {
                id: 'totalWithoutTaxWithComplements',
                dataKey: 'totalWithoutTaxWithComplements',
                simpleLabel: t('totalWithComplements', 'Total con complementos'),
                label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
                component: 'ITDisplayEditFinalPriceBase',
                skipEdit: true,
                with_vat: true,
                width: 105,
                hideColumnByDefault: true,
                toolTip: t('totalWithComplements', 'Total con complementos')
            },
            {
                id: 'totalWithoutTaxWithComplementsPrev',
                dataKey: 'totalWithoutTaxWithComplementsPrev',
                simpleLabel: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de desc.'),
                label: () => <div className='text-right w-full'> {t('withComplementsS', 'Con comp.')}</div>,
                component: 'ITDisplayEditFinalPriceBase',
                skipEdit: true,
                with_vat: true,
                width: 105,
                hideColumnByDefault: true,
                toolTip: t('totalWithoutTaxWithComplementsPrev', 'Total con complementos antes de descuentos'),
            },
            {
                id: 'unitPriceWithComplements',
                dataKey: 'unitPriceWithComplements',
                simpleLabel: t('unitPriceWithComplements', 'Precio unitario con complementos'),
                label: () => <div className='text-right w-full'> {t('unitPricewithComplementsS', 'P. U. comp.')}</div>,
                component: 'ITDisplayPrice',
                width: 110,
                hideColumnByDefault: true,
                toolTip: t('unitPriceWithComplements', 'Precio unitario con complementos'),
            }
        )
    }
    const columns: ColumnOrderTableSchema<ProductExtendedTyInputTableListing & SellTicketProductModelType > = [
        {
            id: 'nLine',
            dataKey: 'nLine',
            label: t('line', 'Línea'),
            width: 70,
            hideColumnByDefault: true
        },
        {
            id: 'url',
            dataKey: 'url',
            label: t('image', 'Imagen'),
            component: 'ITDisplayImage',
            width: 60
        },
        {
            id: 'code_bar',
            dataKey: 'code_bar',
            label: t('codeBarShort', 'Cod. de barras'),
            simpleLabel: t('codeBar', 'Código de barras'),
            component: 'OrderSearchProductInput',
            field: 'code_bar',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            hideColumnByDefault: true,
            minWidth: 115
        },
        {
            id: 'reference',
            dataKey: 'reference',
            label: t('reference', 'Referencia'),
            component: 'OrderSearchProductInput',
            field: 'reference',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            minWidth: 100,
            hideColumnByDefault: true,
            className: 'sell_ticket_reference_name'
        },
        {
            id: 'name',
            dataKey: 'name',
            label: t('name', 'Nombre'),
            component: 'OrderSearchProductInputName',
            field: 'referenceAndName',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            className: 'sell_ticket_reference_name',
            displayField: 'name'
        },
        {
            id: 'referenceAndName',
            dataKey: 'name',
            label: t('referenceName', 'Referencia y nombre'),
            component: 'OrderSearchProductInputReferenceAndName',
            field: 'referenceAndName',
            typeOnChange: 'onChangeAdd',
            sortable: true,
            minWidth: 180,
            className: 'sell_ticket_reference_name',
            hideColumnByDefault: true,
        },
        {
            id: 'packQuantity',
            dataKey: 'packQuantity',
            label: '',
            simpleLabel: t('changeUnit', 'Editar unidades'),
            component: 'OrderChangePackUnit',
            width: 35,
            hideColumnByDefault: true,
        },
        {
            id: 'editProduct',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('buttonSeeProduct', 'Botón de ver producto'),
            component: 'OrderEditProduct',
            width: 35,
            havePermission: permissionCheck(getUserPermissions('product.profile.main'), 'read'),
            hideColumnByDefault: true,
        },
        {
            id: 'descriptionDocuments',
            dataKey: 'descriptionDocuments',
            label: t('description', 'Descripción'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'shortDescriptionDocuments',
            dataKey: 'shortDescriptionDocuments',
            label: t('shortDescriptionS', 'Desc. corta'),
            simpleLabel: t('shortDescription', 'Descripción corta'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue} />,
            hideColumnByDefault: true
        },
        {
            id: 'notes',
            dataKey: 'notes',
            label: t('notes', 'Notas'),
            component: 'ITEditableText',
            typeOnChange: 'onChangeFetch',
            hideColumnByDefault: true
        },
        ...priceColumns,
        {
            id: 'manualPrice',
            dataKey: 'manualPrice',
            label: t('syncPriceS', 'Sinc. P.'),
            simpleLabel: t('syncPrice', 'Sincronizar precio'),
            toolTip: t('ifChangedPricesyncPrice', 'Si has actualizado el precio manualmente, desde aquí podrás poner el precio original'),
            component: 'OrderSyncProductPrice',
            hideColumnByDefault: true,
            minWidth: 100,
        },
        {
            id: 'quantity',
            dataKey: 'quantity',
            label: t('quantity', 'Cantidad'),
            customRender: (parameterValue, allRowData) => <ITTypeQuantityDisplay measure={allRowData.typeQuantity} value={parameterValue} />,
            width: 100,
        },
        {
            id: 'quantity2',
            dataKey: 'quantity2',
            label: t('quantitySecondRes', 'Cant. sec.'),
            simpleLabel: t('quantitySecondary', 'Cantidad secundaria'),
            customRender: (parameterValue, allRowData) => <ITTypeQuantityDisplay measure={allRowData.typeQuantity2} value={parameterValue} />,
            width: 100,
            hideColumnByDefault: true
        },
        {
            id: 'wasteWeight',
            dataKey: 'wasteWeight',
            label: t('wasteWeight', 'Merma'),
            customRender: (parameterValue) => <CustomRenderString value={parameterValue ? parameterValue + ' %' : ''} />,
            width: 100,
            hideColumnByDefault: true,
        },
        {
            id: 'calculatedQuantity',
            dataKey: 'calculatedQuantity',
            label: t('quantityCalculatedS', 'Cant. calc.'),
            toolTip: t('quantityCalculated', 'Cantidad calculada'),
            simpleLabel: t('quantityCalculated', 'Cantidad calculada'),
            width: 110,
            hideColumnByDefault: true,
            customRender: (parameterValue, allRowData) => <ITTypeQuantityDisplay measure={allRowData.typeQuantity} value={parameterValue} />
        },
        ...priceColumns2,
        {
            id: 'editAddonProduct',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('buttonAddAddonProduct', 'Botón de añadir complemento'),
            component: 'OrderEditAddonProduct',
            width: 33,
            completeData: completeData,
            hideColumnByDefault: true,
        },
        {
            id: 'deleteRow',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('deleteLine', 'Eliminar línea'),
            width: 31,
            component: 'ITDeleteRow',
            requiredColumn: true
        },
        {
            id: 'dragLine',
            dataKey: 'nLine',
            label: '',
            simpleLabel: t('moveLine', 'Mover línea'),
            width: 31,
            component: 'ITDragHandle',
            requiredColumn: true,
            hideColumnByDefault: true,
        },
        {
            id: 'PrintTags',
            dataKey: 'ProductId',
            label: '',
            simpleLabel: t('printTags', 'Imprimir etiquetas'),
            width: 31,
            component: 'OrderPrintTags',
            hideColumnByDefault: true
        },
    ]
    const myUserPermissions = getUserPermissions(['sell.tickets']) || { n: 1, permission: 'read' }
    return (
        <OrderSellTicketTPVLayout name='sellTicketTable' {...{ columns, completeData, setCompleteData, inputTableURLs, orderHeaderURLs, setTableConfiguration, getCompleteData, tableConfiguration, title, userPermissions: myUserPermissions, TableButtons: SellTicketCreateStepButtons, modelId: 'SellTicketId' }} />
    )
}

export default SellTicketCreateNoPermissionStep